
import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, Type, EmbeddedViewRef, ComponentRef, NgZone, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DialogConfig } from '../components/dialog/dialog-config';
import { DialogInjector } from '../components/dialog/dialog-injector';
import { DialogRef } from '../components/dialog/dialog-ref';
import { DialogComponent } from '../components/dialog/dialog.component';
import { DialogModule } from '../components/dialog/dialog.module';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from 'src/modules/base/services/translate.service';
@Injectable({
    providedIn: DialogModule
})
export class SmartModalService {
    dialogComponentRef: ComponentRef<DialogComponent>;
    private readonly _afterClosed = new Subject<any>();
    afterClosed: Observable<any> = this._afterClosed.asObservable();
    title: any = '';
    constructor(@Inject(DOCUMENT) private document: any,private componentFactoryResolver: ComponentFactoryResolver, private appRef: ApplicationRef, private injector: Injector, private DialogRef: DialogRef, private ngZone: NgZone, private translateService : TranslateService) { }

    // (component: any, data: any, title: string, size: ModalSize = ModalSize.Md, position: string = 'center', closable: boolean = true)

    public open(componentType: Type<any>, ...theArgs): Observable<any> {
        this.translateService.translate(theArgs[1] ? theArgs[1] : '').subscribe(trans => {
            if (trans) {
                this.title = trans;
            }
            else{
                this.title = "";
            }
        });
        this.document.body.classList.add('modal-open');
        const dialogRef = this.appendDialogComponentToBody(theArgs[0]);
        this.dialogComponentRef.instance.data = theArgs[0];
        this.dialogComponentRef.instance.size = theArgs[2];
        this.dialogComponentRef.instance.title = this.title;//theArgs[1];
        this.dialogComponentRef.instance.closehide = theArgs[3];
        this.dialogComponentRef.instance.className = theArgs[4];
        this.dialogComponentRef.instance.childComponentType = componentType;
        this._afterClosed['observers'] = [];
        return this._afterClosed.asObservable();
    }
    private appendDialogComponentToBody(config: DialogConfig) {
        const map = new WeakMap();
        map.set(DialogConfig, config);
        const dialogRef = new DialogRef(this.document);
        map.set(DialogRef, dialogRef);
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DialogComponent);
        const componentRef = componentFactory.create(new DialogInjector(this.injector, map));
        this.appRef.attachView(componentRef.hostView);
        const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);
        const sub = dialogRef.afterClosed.subscribe(() => {
            this.removeDialogComponentFromBody(componentRef);
            sub.unsubscribe();
        });
        this.dialogComponentRef = componentRef;
        return dialogRef;
    }
    private removeDialogComponentFromBody(dialogComponentRef: ComponentRef<DialogComponent>) {
        this.appRef.detachView(this.dialogComponentRef.hostView);
        dialogComponentRef.destroy();
    }
    public sendResult(result: any) {
        this.ngZone.run(() => {
            this._afterClosed.next({ result: result });
            this.DialogRef.close({ result: result });
            if(document.getElementsByClassName('kx-cstm-popup-overlay').length == 1)
                this.document.body.classList.remove('modal-open');
        });
    }
    close(result?: any) {
        this.ngZone.run(() => {
            this.DialogRef.close(true);
            this._afterClosed.next({ result: result });
            if(document.getElementsByClassName('kx-cstm-popup-overlay').length == 1)
                this.document.body.classList.remove('modal-open');
        });
    }

    public onModalClose(): Observable<boolean> {
        return this._afterClosed.asObservable();
    }
}

export enum ModalSize {
    Sm, Md, Lg, Xl, XXl
}
// import { Injectable, Type, Component } from '@angular/core';
// import { Observable, defer, Subject, of, merge } from 'rxjs';
// import { mergeMap, take, mapTo } from 'rxjs/operators';
// import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { ModalComponent } from '../components/modal/modal.component';
// @Injectable()
// export class SmartModalService {
//     bsModalRef: BsModalRef;
//     private _isOpen: Observable<boolean>;
//     private modalResult: Subject<ModalResult> = new Subject<ModalResult>();
//     private modalOpen: Subject<ModalRequestEvent> = new Subject<ModalRequestEvent>();
//     private modalClose: Subject<boolean> = new Subject<boolean>();

//     constructor(
//         private bsModalService: BsModalService
//         ) {
//         this._isOpen = merge(this.modalOpen.pipe(mapTo(true)), this.modalClose.pipe(mapTo(false)));
//     }

//     public open(component: any, data: any, title: string, size: ModalSize = ModalSize.Md, position: string = 'center', closable: boolean = true): Observable<ModalResult> {
//         return defer(() => {
//             // Close old modal and open new one
//             // this.modalClose.next(true);
//             const initialState = {
//                 data: data,
//                 title : title,
//                 size : size,
//                 position : position,
//                 closable : closable
//             }
//             this.bsModalRef = this.bsModalService.show(ModalComponent, {initialState});
//             return this.modalResult.pipe(take(1)).pipe(mergeMap(result => {
//                     this.close();
//                     if (result) {
//                         return of(result);
//                     }

//                     throw new Error('Modal closed!');
//             }));
//             // this.bsModalService.onShown.subscribe((result) => {
//             //     this.close();
//             //     return of(result);
//             // })
//             // this.modalOpen.next(new ModalRequestEvent(component, data, title, size, position, closable));

//             // // Return observable for the next modal result
//             // return this.modalResult.pipe(take(1)).pipe(mergeMap(result => {
//             //     this.close();
//             //     if (result) {
//             //         return of(result);
//             //     }

//             //     throw new Error('Modal closed!');
//             // }));

//         });
//     }

//     public close(): void {
//         //this.modalClose.next(true);
//         this.bsModalRef.hide();
//     }

//     public onModalOpen(): Observable<ModalRequestEvent> {
//         return this.modalOpen.asObservable();
//     }

//     public onModalClose(): Observable<boolean> {
//         return this.modalClose.asObservable();
//     }

//     public sendResult(result: any) {
//         // this.bsModalService.onShown.subscribe((result) => {
//         //     this.modalResult.next(result ? new ModalResult(result) : null);
//         // })
//        this.modalResult.next(result ? new ModalResult(result) : null);
//     }

//     public isOpen(): Observable<boolean> {
//         return this._isOpen;
//     }
// }

// export class ModalRequestEvent {

//     constructor(
//         public component: Type<Component>,
//         public data: any,
//         public title: string,
//         public size: ModalSize,
//         public position: string,
//         public closable = true
//     ) { }
// }

// export class ModalResult {

//     constructor(public result: any) { }
// }

// export enum ModalSize {
//     Sm, Md, Lg, Xl, XXl
// }